/**
 * 【【KYMW2100】VO
 *
 * @export OrderNumListModel
 * @class OrderNumListModel
 */
export class OrderNumListModel {
  /** 受注コード */
  public OrderCode = String('');
  /** 媒体区分 */
  public MediumType = String('');
  /** 生協コード */
  public CoopCode = String('');
  // 注文コードVOリスト
  public OrderNumVOList: Array<any> = [];
}
